import { useOrganizations } from '@contexts/organizations-provider';
import { useInstructorsPendingLetter } from '@features/instructors/hooks/use-instructors-pending-letter/useInstructorsPendingLetter';
import * as React from 'react';

import type {
  InstructorsPendingLetterContextValue,
  InstructorsPendingLetterProviderProps,
} from './InstructorsPendingLetterContext.types';

const InstructorsPendingLetterContext = React.createContext<
  InstructorsPendingLetterContextValue | undefined
>(undefined);

const InstructorsPendingLetterProvider = React.memo(
  ({
    children,
  }: Readonly<InstructorsPendingLetterProviderProps>): React.ReactElement => {
    const { selectedOrganization } = useOrganizations();

    const { data, isLoading, isError } = useInstructorsPendingLetter({
      customerId: selectedOrganization?.customerId ?? '',
    });

    const contextValue: InstructorsPendingLetterContextValue = React.useMemo(
      () => ({ data, isLoading, isError }),
      [data, isLoading, isError]
    );

    return (
      <InstructorsPendingLetterContext value={contextValue}>
        {children}
      </InstructorsPendingLetterContext>
    );
  }
);

InstructorsPendingLetterProvider.displayName =
  'InstructorsPendingLetterProvider';
export { InstructorsPendingLetterProvider, InstructorsPendingLetterContext };
